// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 682) return "static/chunks/682-8948305d9b2ff641.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"119":"396464d2","336":"b3a13d7d"}[chunkId] || chunkId) + "." + {"119":"4c60a3c9f6ddd0dc","186":"47dd82f8dbadceca","336":"ecd7b1b4a16ba332","461":"77cfbef2eba094f5","486":"9b6ad8e4ef12d0db"}[chunkId] + ".js";
};